import React from "react";
import { CustomInputText } from "../../CustomInputText";
import { CustomButtonsForm } from "../../CustomButtonsForm";
import { useForm, Controller } from "react-hook-form";

export const CreateServiceForm = (props) => {

    const { action } = props;
    const { handleSubmit, control, formState: { errors } } = useForm();

    return (
        <form style={{ margin: '30px 30px 20px 30px', position: 'relative',  width: 420 }} onSubmit={ handleSubmit(action) }>
            <div style={{ height: '60%' }}>

                <Controller 
                    name='servicio'
                    control={ control }
                    defaultValue=''
                    render={({ field: { onChange, value } }) => (
                        <CustomInputText
                            label="Servicio"
                            placeholder=""
                            error={ errors?.servicio } 
                            onChange={ onChange }
                            value={ value }
                        />
                    )}
                    
                    rules={{ 
                        required: 'El campo es obligatorio.',
                        pattern: {
                            value: /^[^\d^\s][a-zA-Z ].+[^\s]$/,
                            message: "El nombre del servicio no es válido.",
                        }
                    }}
                />
            </div>

            <CustomButtonsForm name='Crear' />
        </form>
    );
};